export const TranslationsHI = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
        zht: '繁體中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
        zht: 'ZHT',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
        zht: '繁體',
    },
    // BASE
    phrases: {
        order_online: 'ऑनलाइन ऑर्डर करें',
        cart: 'कार्ट',
        open_24: '24 घंटे खुला',
        closed: 'बंद',
        free: 'मुफ़्त',
        something_went_wrong: 'कुछ गलत हो गया',
        try_again: 'पुनः प्रयास करें',
    },
    constants: {
        calendar: {
            days: {
                monday: 'सोमवार',
                tuesday: 'मंगलवार',
                wednesday: 'बुधवार',
                thursday: 'गुरुवार',
                friday: 'शुक्रवार',
                saturday: 'शनिवार',
                sunday: 'रविवार',
            },
        },
        services: {
            pickup: 'पिकअप',
            delivery: 'डिलीवरी',
            dine_in: 'रेस्तरां में भोजन',
            table_booking: 'टेबल बुकिंग',
        },
        payment: {
            method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'क्रेडिट कार्ड',
                paypal: 'PayPal',
                cardconnect: 'क्रेडिट कार्ड',
                checkout: 'Checkout',
                checkout_apple_pay: 'ऐप्पल पे (चेकआउट.कॉम)',
                checkout_google_pay: 'Google पे (Checkout.com)',
                razor_pay: 'रेजर पे',
                paygate_payweb: 'पेगेट पेवेब',
                poli_pay: 'पोली भुगतान',
                ipay88: 'iPay88',
                bambora_apac: 'बम्बोरा एपीएसी',
                pesapal: 'Pesapal',
                ath_movil: 'एटीएच मोविल',
                custom: 'Custom',
                red_dot: 'रेड डॉट भुगतान',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'एबीए भुगतान',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'विवा वॉलेट',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net',
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'पेगेट पेवेब',
                poli_pay: 'पोली भुगतान',
                ipay88: 'iPay88',
                bambora_apac: 'बम्बोरा एपीएसी',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'एटीएच मोविल',
                checkout: 'Checkout',
                checkout_apple_pay: 'ऐप्पल पे (चेकआउट.कॉम)',
                checkout_google_pay: 'Google पे (Checkout.com)',
                stripe_digital_wallet: 'गूगल/एप्पल पे',
                razor_pay: 'रेजर पे',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'रेड डॉट भुगतान',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'एबीए भुगतान',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'विवा वॉलेट',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online',
            },
            status: {
                success: 'सफल',
                pending: 'लंबित',
                error: 'त्रुटि',
                refunded: 'रिफंड किया गया',
                refunding: 'रिफंड किया जा रहा है',
                partial_refunded: 'आंशिक रूप से रिफंड किया गया',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'हटाएं',
                drop_here: 'अपनी फ़ाइलें यहाँ छोड़ें या किसी एक को चुनने के लिए क्लिक करें',
                accepts: '{{fileTypes}} फ़ाइलें स्वीकार करता है',
                errors: {
                    max_files: 'अधिकतम {{number}} फ़ाइलों की अनुमति है',
                    max_size: 'अधिकतम फ़ाइल आकार {{kilobytes}} KB है',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'स्टोर फिलहाल बंद है और तत्काल देय भोजन का ऑर्डर नहीं दिया जा सकता। आप इसके बजाय बाद की तारीख और समय के लिए ऑर्डर करने का प्रयास कर सकते हैं',
            },
            buttons: {
                order: {
                    book_order: 'टेबल बुक करें / ऑनलाइन ऑर्डर करें',
                    order_online: 'ऑनलाइन ऑर्डर करें',
                    book_table: 'टेबल बुक करें',
                    order: 'ऑर्डर करें',
                    book: 'बुक करें',
                    cart: 'कार्ट',
                    restart: 'फिर से शुरू करें',
                    closed: 'स्टोर बंद',
                    not_accepting: 'ऑर्डर स्वीकार नहीं कर रहा है',
                },
            },
        },
        modals: {
            auth: {
                login: 'लॉग इन',
                register: 'रजिस्टर करें',
                register_commence: 'जारी रखें',
                register_complete: 'खाता बनाएं',
                register_confirmation_sent: 'आपके ई-मेल पते पर एक पुष्टिकरण कोड भेज दिया गया है। आगे बढ़ने के लिए कृपया इसे नीचे दर्ज करें',
                register_confirmation_resent: 'पुष्टिकरण कोड दोबारा भेज दिया गया है, अपना स्पैम जांचें या प्रक्रिया पुनः आरंभ करें',
                register_restart: 'फिर से शुरू करें',
                register_resend_code: 'पुन: कोड भेजे',
                register_confirmation_code_subject: 'ई-मेल पुष्टिकरण कोड',
                register_confirmation_code_email: 'आपका ईमेल पुष्टिकरण कोड {{confirmation_code}} है (24 घंटे में समाप्त हो जाएगा)',
                login_placeholder: 'ईमेल',
                password_placeholder: 'पासवर्ड',
                confirm_password_placeholder: 'पासवर्ड की पुष्टि कीजिये',
                confirmation_code_placeholder: 'ई-मेल पुष्टिकरण कोड',
                accept_terms: 'नियम एवं शर्तें स्वीकार करें',
                accept_terms_view: 'देखें',
                login_facebook: 'फ़ेसबुक लॉगिन करें',
                login_google: 'गूगल से लॉगिन करें',
                benefits: 'अपने सभी ऑर्डर सहेजने के लिए लॉगिन करें या एक खाता बनाएं',
                logged_in: 'सफलतापूर्वक लॉग इन किया गया',
                logged_out: 'बाहर आ गये',
                password_reset: {
                    init_button: 'पासवर्ड रीसेट मेल भेजें',
                    init_success: 'पासवर्ड रीसेट लिंक आपके ई-मेल पर भेज दिया गया है',
                    complete_button: 'पासवर्ड रीसेट',
                    complete_success: 'पासवर्ड सफलतापूर्वक रीसेट हो गया, अपने नए पासवर्ड से लॉगिन करें',
                    forgot_password_text: 'अपना पासवर्ड भूल गये?',
                    forgot_password_link: 'पासवर्ड रीसेट',
                    remember_password_text: 'अपना पासवर्ड याद रखें?',
                    remember_password_link: 'वापस जाओ',
                    invalid_title: 'पासवर्ड रीसेट अमान्य',
                    invalid_description: 'यह पासवर्ड रीसेट लिंक मान्य नहीं है, इसके बजाय एक नए का अनुरोध करें',
                    invalid_link: 'लॉगइन पर जाएं',
                    title: 'पासवर्ड रीसेट',
                    description: 'अपने खाते के लिए एक नया पासवर्ड दर्ज करें',
                },
                error_generic: 'कुछ गलत हो गया, कृपया पुनः प्रयास करें या हमसे संपर्क करें',
                error_accept_terms: 'कृपया नियम एवं शर्तें स्वीकार करें',
                error_password_length: 'पासवर्ड के लिए न्यूनतम 6 अक्षर',
                error_social: 'कुछ गलत हो गया, पुनः प्रयास करें या हमसे संपर्क करें',
                error_confirmation_code: 'अवैध पुष्टि कोड',
                error_invalid_code: 'अवैध पुष्टि कोड',
                error_exists: 'उपयोगकर्ता पहले से ही मौजूद है',
                error_invalid_email_pass: 'अमान्य ई - मेल पता अथवा पासवर्ड',
                error_password_no_match: 'पासवर्ड एक दूसरे से मेल नहीं खाते',
                error_user_not_found: 'उस ई-मेल पते वाला कोई उपयोगकर्ता नहीं',
                error_invalid_email: 'अमान्य ईमेल पता',
                error_invalid_reset_token: 'अमान्य रीसेट लिंक, दूसरे का अनुरोध करें',
            },
            booking: {
                form: {
                    name: 'पूरा नाम',
                    email: 'मेल पता',
                    phone: 'फ़ोन नंबर',
                    number_of_people: 'लोगों की संख्या',
                    number_of_people_max: 'लोगों की संख्या ({{max_people}} अधिकतम)',
                    number_of_people_min: 'लोगों की संख्या ({{min_people}} मिनट)',
                    number_of_people_max_min: 'लोगों की संख्या ({{min_people}} से {{max_people}} के बीच)',
                    notes: 'नोट्स/विशेष अनुरोध',
                    submit: 'बुकिंग अनुरोध सबमिट करें',
                    email_optional: '(वैकल्पिक)',
                    date: 'तारीख',
                    duration: 'अवधि',
                    seating: 'उपलब्ध समय',
                    number_of_guests: 'मेहमानों की संख्या',
                    notes_placeholder: 'एलर्जी, अवसर, बैठने की पसंद',
                    reserving: 'आरक्षण हो रहा है...',
                    reserve_table: 'टेबल बुक करें',
                    please_choose_a_date_and_time: 'कृपया तारीख और समय चुनें।',
                    invalid_people: 'लोगों की संख्या {{min}} और {{max}} के बीच होनी चाहिए।',
                    party_size_max_fallback: 'अनुमत अधिकतम',
                    loading_available_times: 'उपलब्ध समय लोड हो रहे हैं…',
                    select_a_date_to_see_available_times: 'उपलब्ध समय देखने के लिए तारीख चुनें।',
                    no_times_available_for_this_date: 'इस तारीख के लिए कोई समय उपलब्ध नहीं है। कृपया कोई और दिन चुनें।',
                    shift: 'शिफ्ट',
                    service_times: 'सेवा समय',
                    new_shift: 'नई शिफ्ट',
                    time: 'समय',
                    times: 'समय',
                    unavailable: 'अनुपलब्ध',
                    available: 'उपलब्ध',
                    required_name: 'कृपया अपना नाम दर्ज करें।',
                    required_phone: 'कृपया अपना फ़ोन नंबर दर्ज करें।',
                    required_email: 'कृपया अपना ईमेल दर्ज करें।',
                    invalid_email: 'कृपया मान्य ईमेल दर्ज करें।',
                    required_terms: 'आरक्षण से पहले शर्तें स्वीकार करें।',
                    reservation_is_unavailable: 'आरक्षण उपलब्ध नहीं है।',
                    please_contact_the_restaurant_directly: 'कृपया रेस्तरां से सीधे संपर्क करें।',
                    almost_done: 'लगभग पूरा',
                    your_details: 'आपका विवरण',
                    tell_us_who_s_coming: 'बताएँ कौन आ रहा है ताकि हम आपका आरक्षण पुष्टि कर सकें।',
                    book_your_table: 'अपनी टेबल बुक करें',
                    choose_a_time_that_works_for_you: 'अपने लिए उपयुक्त समय चुनें।',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'अपना आरक्षण अनुरोध भेजें, बाकी रेस्तरां संभाल लेगा।',
                    select_date: 'तारीख चुनें',
                    standard: 'मानक',
                    minutes: 'मिनट',
                    next: 'आगे →',
                    back: '← वापस',
                    accept_terms: 'मैं नियम और शर्तें स्वीकार करता/करती हूँ।',
                    info_1: 'आपकी बुकिंग स्वीकार या अस्वीकृत होने पर आपको एक ई-मेल सूचना प्राप्त होगी',
                },
                errors: {
                    not_found: 'बुकिंग मौजूद नहीं है। संभवतः इसे हटा दिया गया है',
                    generic: 'कुछ ग़लत हो गया, पृष्ठ ताज़ा करें या हमसे संपर्क करें',
                    something_went_wrong: 'कुछ गलत हो गया',
                    accept_terms: 'कृपया नियम एवं शर्तें स्वीकार करें',
                    required_phone: 'कृपया अपना फोन नंबर दर्ज करें',
                    required_email: 'कृपया अपना ईमेल दर्ज करें',
                    required_zip: 'कृपया अपना बिलिंग ज़िप कोड दर्ज करें',
                    required_name: 'कृपया अपना नाम दर्ज करें',
                    invalid_email: 'कृपया एक मान्य ईमेल पता प्रविष्ट करें',
                    invalid_phone: 'एक मान्य दूरभाष क्रमांक दर्ज करे',
                    invalid_people: 'लोगों की अमान्य संख्या',
                    missing_custom_fields: 'कृपया सभी अपेक्षित फ़ील्ड को भरें।',
                    booking_capacity_threshold: 'इस समय के लिए हम पूरे बुक हैं। कृपया कोई और समय आज़माएँ।',
                    slot_unavailable: 'इस संख्या के लिए हम पूरे बुक हैं। कृपया कोई और समय आज़माएँ।',
                    booking_date_paused: 'इस तारीख के लिए बुकिंग रोकी गई है। कृपया कोई और दिन चुनें।',
                    invalid_table_assignment: 'वे टेबल आपके समूह को नहीं बैठा सकतीं। कृपया कोई और समय चुनें।',
                    exceeded_order_limit: 'बहुत अधिक बुकिंग अनुरोध। कृपया बाद में पुनः प्रयास करें।',
                    validation_failed_recaptcha_v3: 'असामान्य ट्रैफ़िक पाया गया। क्या आप VPN उपयोग कर रहे हैं? ऊपर दिया सत्यापन पूरा करें और पुनः प्रयास करें।',
                    validation_failed_recaptcha_v2: 'बुकिंग शुरू नहीं हो सकी। कृपया पुनः प्रयास करें या कोई और तरीका अपनाएँ। यदि आप VPN उपयोग कर रहे हैं, तो पहले उसे बंद करें।',
                    booking_already_exists: 'यह आरक्षण पहले ही भेजा जा चुका है। अपना ईमेल जाँचें या बुकिंग लिंक खोलें।',
                    invalid_party_size: 'कृपया मान्य संख्या चुनें।',
                    invalid_request: 'अमान्य अनुरोध। कृपया पेज रीफ़्रेश करें और पुनः प्रयास करें।',
                    table_booking_unavailable: 'टेबल बुकिंग उपलब्ध नहीं है।',
                },
            },
            cart: {
                title: 'कार्ट',
                proceed_to_checkout: 'चेकआउट के लिए आगे बढ़ें',
                edit_dish: 'संपादित करें',
                remove_dish: 'हटाएं',
                no_items_1: 'कार्ट में कोई आइटम नहीं',
                no_items_2: 'आगे बढ़ने के लिए पहले कुछ जोड़ें',
                free_delivery_notice: '{{value, currency}} से अधिक के ऑर्डर के लिए निःशुल्क डिलीवरी',
                errors: {
                    min_order_promo: 'इस प्रोमो को लागू करने से पहले न्यूनतम कार्ट मान {{value, currency}} आवश्यक है',
                    min_order_delivery: 'डिलीवरी के लिए न्यूनतम कार्ट मूल्य {{value, currency}}',
                },
                promo: {
                    heading: 'प्रचार कोड',
                    placeholder: 'अपना प्रोमो कोड दर्ज करें',
                    add: 'कोड जोड़ें',
                    title: 'प्रोमो {{name}} कार्ट में जोड़ा गया',
                    fixed_discount: '{{value, currency}} बंद',
                    percent_discount: '{{value}}% छूट',
                    added_to_cart: 'प्रोमो कार्ट में जोड़ा गया',
                    errors: {
                        not_found: 'प्रोमो नहीं मिला',
                        disabled: 'प्रोमो अक्षम है',
                        not_available: 'प्रोमो फिलहाल उपलब्ध नहीं है',
                        not_eligible: 'प्रमोशनल कोड लागू करने के योग्य नहीं',
                        not_available_time: 'प्रोमो इस समय के लिए लागू नहीं है',
                        logged_in_only: 'इस प्रोमो का उपयोग करने के लिए लॉग इन होना चाहिए',
                        already_used: 'आप पहले ही इस प्रोमो का उपयोग कर चुके हैं',
                        invalid: 'यह प्रोमो अब मान्य नहीं है',
                        invalid_service: 'यह प्रोमो आपकी चुनी गई सेवा के लिए मान्य नहीं है',
                        later_only: 'केवल प्री-ऑर्डर के लिए मान्य',
                        now_only: 'केवल तत्काल देय ऑर्डरों के लिए मान्य, पूर्व-ऑर्डर के लिए नहीं',
                        generic: 'उफ़... कुछ ग़लत हो गया और लॉग कर दिया गया है',
                        dishes_required_multi: 'यह प्रोमो केवल तभी लागू होगा जब आपके कार्ट में कुछ आइटम जोड़े जाएंगे',
                        dishes_required_single: 'यह ऑफ़र केवल \'{{dish}}\' पर लागू होगा',
                    },
                },
                tip: {
                    title: 'ऑर्डर टिप',
                    placeholder: 'ऑर्डर टिप जोड़ें',
                },
            },
            free_items_promo: {
                title: 'मुफ़्त आइटम',
                usage_confirmation: {
                    question: 'आप मुफ़्त आइटम के लिए पात्र हैं. क्या आप उन्हें देखना और जोड़ना चाहेंगे?',
                    cancellation: 'नहीं, मुझे मुफ़्त आइटम नहीं चाहिए',
                    acceptance: 'हाँ',
                },
                free_items_selection: {
                    multiple: {
                        description: '{{number}} मुफ़्त आइटम चुनें',
                    },
                    single: {
                        description: 'एक निःशुल्क वस्तु का चयन करें',
                    },
                    confirm_button: 'पुष्टि करें',
                },
            },
            checkout: {
                title: 'चेकआउट',
                subtitle: 'अपने ऑर्डर विवरण की पुष्टि करें',
                details: {
                    service: 'सेवा',
                    due: 'समय',
                    due_now_asap: 'अभी / यथाशीघ्र',
                    address: 'डिलीवरी का पता',
                    total: 'कुल',
                    table: 'टेबल',
                    store_location: 'स्टोर का पता',
                },
                customer: {
                    title: 'ग्राहक',
                    subtitle: 'अपने ऑर्डर और विवरण सहेजने के लिए लॉगिन करें',
                    button: 'लॉग इन करें',
                    name: 'पूरा नाम',
                    email: 'ईमेल',
                    phone: 'फ़ोन',
                    phone_important: 'फ़ोन (महत्वपूर्ण)',
                    notes: 'ऑर्डर नोट',
                    delivery_notes: 'डिलीवरी निर्देश / ऑर्डर नोट्स',
                    optional: 'वैकल्पिक',
                },
                payment: {
                    title: 'भुगतान विधि',
                    qr_modal_help: 'QR को स्कैन करने और इस ऑर्डर के लिए भुगतान पूरा करने के लिए अपने {{app}} मोबाइल एप्लिकेशन का उपयोग करें। एक बार आपके मोबाइल एप्लिकेशन पर भुगतान पूरा हो जाने के बाद, आप इस क्यूआर मोडल को बंद कर सकते हैं। यदि आपने अपनी भुगतान प्रक्रिया पूरी नहीं की है तो कृपया इस क्यूआर मोडल को बंद न करें।',
                    switch_to_app_help: 'नीचे दिए गए बटन को दबाने पर, इस ऑर्डर का भुगतान पूरा करने के लिए {{app}} मोबाइल एप्लिकेशन स्वचालित रूप से खुल जाएगा। एक बार आपके मोबाइल एप्लिकेशन पर भुगतान पूरा हो जाने पर, आप इस मोडल को बंद कर सकते हैं। यदि आपने अपनी भुगतान प्रक्रिया पूरी नहीं की है तो कृपया इस मोडल को बंद न करें।',
                    open_app: '{{app}} एप्लिकेशन खोलें',
                    continue: 'जारी रखें',
                    continue_to_payment: '{{method}} पर जारी रखें',
                    back_to_cart: 'कार्ट पर वापस जाएँ',
                },
                accept_terms: 'नियम एवं शर्तें स्वीकार करें',
                accept_terms_view: 'देखें',
                processing_order: 'प्रसंस्करण आदेश',
                warning: {
                    different_payment_currency: 'स्टोर की कीमतें {{store_currency}} में हैं लेकिन भुगतान विधि {{payment_currency}} में है',
                    closing_soon: 'जल्द ही बंद हो रहा है, ऑर्डर {{value}} मिनट के भीतर दिए जाने चाहिए',
                    closed: 'क्षमा करें, यह सेवा बंद हो गई है और ऑर्डर स्वीकार नहीं किए जा रहे हैं',
                    paused: 'क्षमा करें, यह सेवा रोक दी गई है और फिलहाल ऑर्डर स्वीकार नहीं किए जा रहे हैं',
                    expired: 'अब हम आपके चयनित समय पर आपका ऑर्डर पूरा नहीं कर सकते। कृपया बाद की कोई तारीख या समय चुनें',
                },
                errors: {
                    walletly_promo: 'वॉलेटली प्रोमो में त्रुटि है, कृपया दूसरा प्रोमो आज़माएँ!',
                    stripe_generic: 'क्रेडिट कार्ड त्रुटि, पुनः प्रयास करें या कोई अन्य तरीका',
                    validation_failed: 'यह भुगतान इस समय स्वीकार नहीं किया जा सकता. कृपया बाद में पुनः प्रयास करें या कोई अन्य भुगतान विधि चुनें।',
                    validation_failed_recaptcha_v3: 'असामान्य ट्रैफ़िक का पता चला. क्या आप वीपीएन का उपयोग कर रहे हैं? कृपया उपरोक्त चुनौती पूरी करें और पुनः प्रयास करें।',
                    validation_failed_recaptcha_v2: 'हम भुगतान आरंभ नहीं कर सके. कृपया पुनः प्रयास करें या किसी अन्य विधि का उपयोग करें। यदि आप वीपीएन का उपयोग कर रहे हैं, तो पहले इसे बंद करने का प्रयास करें।',
                    stripe_loading_fail: 'भुगतान फ़ॉर्म लोड करने में त्रुटि, कृपया पुनः प्रयास करें',
                    something_went_wrong: 'कुछ गलत हो गया',
                    paypal_generic: 'PayPal के साथ कुछ गलत हो गया, पुनः प्रयास करें या कोई अन्य भुगतान विधि चुनें',
                    payment_fail: 'भुगतान विफल रहा, कृपया पुनः प्रयास करें या कोई अन्य भुगतान विधि चुनें',
                    payment_cancelled: 'भुगतान रद्द कर दिया गया, कृपया पुनः प्रयास करें या कोई अन्य भुगतान विधि चुनें',
                    payment_error: 'ऑनलाइन भुगतान संसाधित करने में त्रुटि, पुनः प्रयास करें या कोई अन्य भुगतान विधि चुनें',
                    payment_declined: 'आपकी भुगतान विधि निरस्त हो गई थी',
                    card_declined: 'आपका कार्ड अस्वीकार कर दिया गया और भुगतान संसाधित नहीं हो सका',
                    promo_max_uses_exceeded: "यह प्रोमो कोड अपनी उपयोग सीमा तक पहुँच चुका है और अब उपलब्ध नहीं है।",
                    store_closed: 'स्टोर बंद है और अब ऑर्डर स्वीकार नहीं किया जा रहा है',
                    accept_terms: 'कृपया नियम एवं शर्तें स्वीकार करें',
                    required_payment: 'एक भुगतान पद्धति का चयन करें',
                    required_phone: 'कृपया अपना फोन नंबर दर्ज करें',
                    required_email: 'कृपया अपना ईमेल दर्ज करें',
                    required_zip: 'कृपया अपना बिलिंग ज़िप कोड दर्ज करें',
                    required_name: 'कृपया अपना नाम दर्ज करें',
                    invalid_email: 'कृपया एक मान्य ईमेल पता प्रविष्ट करें',
                    invalid_phone: 'एक मान्य दूरभाष क्रमांक दर्ज करे',
                    invalid_cc_number: 'आपका क्रेडिट कार्ड नंबर अमान्य है',
                    invalid_order_amount: 'इस भुगतान विधि के लिए आवश्यक न्यूनतम राशि',
                    retry_cc_number: 'कुछ गलत हो गया, अपना क्रेडिट कार्ड नंबर पुनः दर्ज करें और पुनः प्रयास करें',
                    closed: 'स्टोर बंद है और ऑर्डर स्वीकार नहीं कर रहा है',
                    promo_login_required: 'इस प्रोमो का उपयोग करने के लिए लॉग इन होना चाहिए',
                    promo_used: 'आप पहले ही इस प्रोमो का उपयोग कर चुके हैं',
                    promo_by_payment_method_not_applicable: 'प्रोमो चयनित भुगतान विधि पर लागू नहीं है।',
                    missing_custom_checkout_fields: 'कृपया सभी अपेक्षित फ़ील्ड को भरें।',
                    delivery_unavailable: 'इस समय डिलीवरी सेवा उपलब्ध नहीं हो सकती है. कृपया इसके बजाय पिक अप ऑर्डर करने पर विचार करें।',
                    required_delivery_provider: 'कृपया एक सेवा वितरण चुनें.',
                    required_delivery_quotation: 'वितरण अनुमान समाप्त हो गया.',
                    exceeded_order_limit: 'हमें इस समय बहुत सारे ऑर्डर मिल रहे हैं। कृपया बाद का समय चुनें.',
                    exceeded_order_limit_later: 'अब हम आपके चयनित समय पर आपका ऑर्डर पूरा नहीं कर सकते। कृपया बाद की कोई तारीख या समय चुनें',
                },
                button: {
                    continue: 'भुगतान जारी रखें',
                    place_order: 'आदेश देना',
                    update_order: 'आर्डर का अद्यतन करें',
                },
                delivery_estimation: {
                    title: 'डिलिवरी अनुमान',
                    details: {
                        provider: 'डिलिवरी प्रदाता',
                        estimated_fee: 'अनुमानित शुल्क',
                        estimated_total_fee: 'डिलिवरी शुल्क कुल',
                        estimated_discount_fee: 'डिलिवरी शुल्क में छूट',
                        previous_estimated_fee: 'पिछला अनुमानित शुल्क',
                        tips: 'बख्शीश',
                        estimated_delivery_time: 'अनुमानित सुपुर्दर्गी समय',
                        uber_new_estimation: 'नए अनुमान का अनुरोध करें',
                        uber_new_estimation_success: 'नया उबर डिलिवरी अनुमान लागू किया गया।',
                        uber_estimation_expired: 'वितरण अनुमान समाप्त हो गया',
                        uber_price: 'हम उबर की कीमत पर पकड़ बनाए हुए हैं',
                        uber_need_time: 'मुझे और समय चाहिए',
                        lalamove_price: 'हम लालामूव डिलीवरी शुल्क का भुगतान कर रहे हैं',
                        lalamove_new_estimation_success: 'नया लाललमूव डिलिवरी अनुमान लागू किया गया।',
                        lalamove_estimation_expired: 'वितरण अनुमान समाप्त हो गया',
                        lalamove_need_time: 'मुझे और समय चाहिए',
                        lalamove_new_estimation: 'नए अनुमान का अनुरोध करें',
                    },
                    quotation_error: 'डिलीवरी अनुमान की गणना में कुछ गड़बड़ी हुई।',
                },
            },
            customer: {
                age_v: {
                    title: 'आयु सत्यापन',
                    required_for_items: 'कुछ वस्तुओं को ऑर्डर करने के लिए आवश्यक है',
                    min_age: 'न्यूनतम आयु: {{age}} वर्ष',
                    est_time: 'अनुमानित सत्यापन समय: {{time}} घंटे',
                    upload_description: 'सत्यापन के लिए नीचे अपनी आईडी अपलोड करें। सत्यापित होने पर आपको ई-मेल के माध्यम से सूचित किया जाएगा। प्रत्येक 2 एमबी के अधिकतम आकार वाली 2 छवियां अपलोड करें',
                    pending_description_1: 'अपने दस्तावेज़ जमा करने के लिए धन्यवाद. स्वीकृत होने पर आपको ई-मेल द्वारा सूचित किया जाएगा',
                    pending_description_2: 'अपनी सत्यापन स्थिति अपडेट करने के लिए पृष्ठ को ताज़ा करें। अनुमानित सत्यापन समय {{time}} घंटे है',
                    approved_description: 'आपका खाता सत्यापित हो चुका है और आप प्रतिबंधित मेनू से ऑर्डर कर सकते हैं',
                    rejected_description: 'आपकी आईडी अस्वीकार कर दी गई है. यदि आप पुनः प्रयास करना चाहते हैं, तो कृपया अपनी आईडी पुनः अपलोड करें',
                    upload: 'अपलोड करें',
                    reupload: 'दस्तावेज़ पुनः अपलोड करें',
                    go_back: 'वापस जाओ',
                    view_document: 'दस्तावेज़ देखें{{number}}',
                    status: {
                        unverified: 'अप्रमाणित',
                        pending: 'अनुमोदन के लिए प्रतीक्षा',
                        approved: 'सफलतापूर्वक सत्यापित',
                        rejected: 'अस्वीकृत',
                    },
                },
                headings: {
                    sessions: 'सत्र',
                    orders: 'ऑर्डर',
                    spend: 'खर्च',
                    order_history: 'ऑर्डर इतिहास',
                    loyalty: 'लॉयल्टी',
                    loyalty_points: 'वफादारी अंक',
                    added: 'प्रोमो जोड़ा गया',
                },
                loyalty_errors: {
                    invalid_cart_items: 'कृपया रिडीम करने से पहले कोई भी आइटम चुनें!',
                    not_found: 'प्रोमो नहीं मिला!',
                    already_exists: 'प्रोमो पहले से मौजूद है!',
                    try_again: 'इस सौदे को लागू नहीं कर सकते. कृपया पुन: प्रयास करें!',
                },
            },
            custom_payment: {
                title: '{{name}} भुगतान प्रपत्र',
                description: 'आप हमारे ऑनलाइन भुगतान फॉर्म तक पहुंच गए हैं। भुगतान करने के लिए कृपया नीचे दिए गए फ़ील्ड को पूरा करें। यदि कोई राशि दर्ज नहीं की गई है, तो आपका विवरण सहेज लिया जाएगा लेकिन आपसे शुल्क नहीं लिया जाएगा।',
                disabled: 'यह ऑनलाइन भुगतान पृष्ठ ठीक से कॉन्फ़िगर नहीं किया गया है. समस्या को सुधारने के लिए कृपया साइट स्वामी से संपर्क करें।',
                success: 'आपका भुगतान सफलतापूर्वक संसाधित हो गया और आपका विवरण सहेज लिया गया है। धन्यवाद',
                back: 'घर वापिस जा रहा हूँ',
                fields: {
                    name: 'पूरा नाम',
                    email: 'मेल पता',
                    reference: 'भुगतान संदर्भ.',
                    amount: 'राशि ($)',
                    name_on_card: 'कार्ड पर नाम',
                    submit: 'भुगतान जमा करें',
                },
                warning: {
                    currency: 'ध्यान दें: भुगतान राशि {{actual}} में है, {{default}} में नहीं',
                },
                errors: {
                    generic: 'कुछ गलत हो गया, पुनः प्रयास करें या हमसे संपर्क करें',
                    stripe_generic: 'क्रेडिट कार्ड त्रुटि, पृष्ठ ताज़ा करें और पुनः प्रयास करें',
                    payment_fail: 'भुगतान विफल रहा, कृपया पुनः प्रयास करें या कोई अन्य भुगतान विधि चुनें',
                    payment_cancelled: 'भुगतान रद्द कर दिया गया, कृपया पुनः प्रयास करें या कोई अन्य भुगतान विधि चुनें',
                    payment_error: 'ऑनलाइन भुगतान संसाधित करने में त्रुटि, पुनः प्रयास करें या कोई अन्य भुगतान विधि चुनें',
                    payment_declined: 'आपकी भुगतान विधि निरस्त हो गई थी',
                    card_declined: 'आपका कार्ड अस्वीकृत हो गया और भुगतान संसाधित नहीं किया जा सका',
                    promo_max_uses_exceeded: "यह प्रोमो कोड अपनी उपयोग सीमा तक पहुँच चुका है और अब उपलब्ध नहीं है।",
                },
            },
            dish: {
                add: 'कार्ट में जोड़ें',
                edit: 'आइटम अद्यतन करें',
                notes: 'विशेष निर्देश...',
                ingredients: {
                    title: 'सामग्री',
                    uncheck_remove: 'हटाने के लिए अनचेक करें',
                },
                ingredients_title: 'सामग्री',
                combo: {
                    choose_dish: 'एक आइटम चुनें',
                },
                option_sets: {
                    conditions: {
                        select_one: 'एक चुनें (आवश्यक)',
                        select_one_optional: 'एक चुनें (वैकल्पिक)',
                        select_between: '{{min}} - {{max}} के बीच चयन करें (आवश्यक)',
                        select_at_least: 'कम से कम {{qty}} चुनें (आवश्यक)',
                        select_up_to: '{{qty}} तक चुनें (वैकल्पिक)',
                        select_multiple_optional: 'एकाधिक चुनें (वैकल्पिक)',
                        select_multiple: 'एकाधिक चुनें (आवश्यक)',
                        free_amount: 'पहला {{qty}} निःशुल्क / {{selected}} चुना गया',
                    },
                    points: {
                        none_consumed: 'आप अधिकतम {{maxFree}} विकल्प निःशुल्क चुन सकते हैं',
                        less_than_total_points: 'आप निःशुल्क अधिक विकल्प चुन सकते हैं',
                        greather_than_total_points: 'आप अतिरिक्त शुल्क के लिए और विकल्प चुन सकते हैं',
                    },
                },
                error: 'कृपया लाल रंग से चिह्नित किसी भी विकल्प को सही करें',
                added_to_cart: 'आइटम कार्ट में जोड़ा गया',
            },
            map: {
                zone_fee: 'वितरण शुल्क',
                view_in_google: 'Google मानचित्र में देखें',
            },
            portal_go_back: {
                title: 'रेस्तरां खोज पर वापस जाएँ?',
                description: 'आपके कार्ट का कोई भी सामान खो जाएगा',
                cancel: 'रद्द करें',
                proceed: 'वापस जाओ',
            },
            order: {
                config: {
                    services: {
                        title: 'एक सेवा चुनें',
                        table_booking: 'टेबल बुक करें',
                    },
                    address_custom: {
                        input_placeholder: 'अपना पता दर्ज करें',
                    },
                    address: {
                        input_placeholder: 'अपना डिलीवरी पता खोजें',
                        extras_placeholder: 'इकाई संख्या, भवन का नाम, वितरण निर्देश, आदि...',
                        search_placeholder: 'अपना पता खोजें',
                        search_input_placeholder: 'खोजने के लिए टाइप करें',
                        no_address_found: 'कोई पता नहीं मिला. 5 से अधिक अक्षर टाइप करने का प्रयास करें',
                        not_found: 'डिलीवरी पता नहीं मिला या मान्य नहीं, पुनः प्रयास करें',
                        not_delivering: 'हम फिलहाल इस पते पर डिलीवरी नहीं कर रहे हैं',
                        not_in_range: 'आपका पता हमारे स्टोर स्थान की सीमा में नहीं है',
                        not_in_zone: 'आपका पता सक्रिय वितरण क्षेत्र में नहीं है',
                        no_number: 'आपके पते पर सड़क का नंबर अवश्य होना चाहिए',
                        location_permission: 'क्या इस वेबसाइट को आपके वर्तमान स्थान तक पहुंचने की अनुमति दें?',
                        location_permission_warning: 'आपकी वर्तमान लोकेशन तक पहुँच नहीं हो सकी। कृपया अपने डिवाइस और वेब ब्राउज़र में लोकेशन सेवा सक्षम करें। यहाँ कुछ संदर्भ दिए गए हैं:',
                        pick_location: 'अपना स्थान चुनें',
                        pick_location_help_text: 'मानचित्र पर स्थान चुनने के लिए मार्कर को खींचें।',
                        use_current_location: 'वर्तमान स्थान का उपयोग करें',
                        locate_on_map: 'मानचित्र पर पता लगाएँ',
                    },
                    datetime: {
                        title: 'आप अपना ऑर्डर कब चाहेंगे',
                        due_now: 'अभी',
                        due_later: 'बाद में',
                        service_not_available: 'क्षमा करें, हम वर्तमान में {{service}} के लिए ऑर्डर स्वीकार नहीं कर रहे हैं',
                        currently_closed: '{{service}} वर्तमान में बंद है लेकिन आप बाद के लिए ऑर्डर कर सकते हैं',
                        due_unavailable: 'उपलब्ध नहीं',
                        due_closed: 'बंद',
                        select_date: 'तारीख़ चुनें',
                        select_time: 'समय चुनें',
                        select_order_date: 'अपना ऑर्डर दिनांक चुनें',
                        select_order_time: 'अपना ऑर्डर समय चुनें',
                        select_order_date_time: 'अपना ऑर्डर दिनांक/समय चुनें',
                        select_booking_date: 'अपनी बुकिंग तिथि चुनें',
                        select_booking_time: 'अपना बुकिंग समय चुनें',
                        no_times_available: 'चुनने के लिए कोई समय उपलब्ध नहीं है',
                        date_today: '(आज)',
                        date_closed: '(बंद)',
                        date_bookings_paused: '(बुकिंग रोकी गई)',
                        time_slot_closed: 'बंद',
                    },
                    number_of_people: {
                        placeholder: 'लोगों की संख्या',
                    },
                    table: {
                        select: 'तालिका का चयन करें',
                        select_popup_title: 'अपनी तालिका चुनें',
                        password: 'टेबल पासवर्ड',
                        password_warning: 'आगे बढ़ने के लिए अपना टेबल पासवर्ड दर्ज करें',
                    },
                    warning: {
                        closed: 'क्षमा करें, हम वर्तमान में बंद हैं/कोई ऑर्डर स्वीकार नहीं कर रहे हैं',
                        not_available: 'क्षमा करें, हम फिलहाल कोई भी ऑर्डर स्वीकार नहीं कर रहे हैं',
                    },
                    eta: {
                        delivery: `अनुमानित डिलीवरी समय लगभग {{minutesToCustomer}} मिनट है`,
                        pickup: `ऑर्डर लगभग {{minutesToCustomer}} मिनट में तैयार हो जाएगा`,
                    },
                    start_button: 'ऑर्डर प्रारंभ करें',
                },
                history: {
                    invalid: 'पुनः ऑर्डर के लिए पात्र नहीं है क्योंकि ऑर्डर की गई कुछ वस्तुओं को संशोधित कर दिया गया है या अब उपलब्ध नहीं हैं',
                },
                reorder: {
                    title: 'त्वरित पुनः आदेश',
                    description: 'अपने पिछले ऑर्डर से आइटम आसानी से ऑर्डर करें',
                },
            },
            receipt: {
                errors: {
                    not_found: 'ऑर्डर नहीं मिला, पृष्ठ ताज़ा करें और पुनः प्रयास करें',
                    booking_not_found: 'बुकिंग मौजूद नहीं है। संभवतः हटा दी गई है',
                    generic: 'कुछ ग़लत हो गया, पृष्ठ ताज़ा करें या हमसे संपर्क करें',
                },
                connection: {
                    connected: 'वास्तविक समय अपडेट',
                    connecting: 'वास्तविक समय अपडेट कनेक्ट हो रहा है',
                    disconnected: 'रीयल-टाइम अपडेट डिस्कनेक्ट हो गए',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'चेतावनी',
                    title: 'लॉग आउट',
                    body: 'लॉग आउट करने से आपके कार्ट में जोड़े गए सभी आइटम हटा दिए जाएंगे',
                    cancel: 'रद्द करें',
                    proceed: 'आगे बढ़ें',
                },
                order_restart: {
                    warning: 'चेतावनी',
                    title: 'ऑर्डर विवरण बदलें',
                    body: 'ऑर्डर विवरण बदलने से आपके कार्ट में मौजूद आइटम हट जाएंगे क्योंकि कुछ आइटम उपलब्ध नहीं हो सकते हैं',
                    cancel: 'रद्द करें',
                    proceed: 'आगे बढ़ें',
                },
                order_expired: {
                    subtitle: 'महत्वपूर्ण',
                    title: 'ऑर्डर को "अभी देय" में बदल दिया गया',
                    description: 'आपके ऑर्डर के लिए चुना गया समय अब उपलब्ध नहीं है। इसलिए आपका ऑर्डर "अभी / यथाशीघ्र" में बदल दिया गया है',
                    button: 'ठीक है',
                },
                order_expiring: {
                    subtitle: 'महत्वपूर्ण',
                    title: 'ऑर्डर की समय सीमा जल्द समाप्त हो रही है',
                    description: 'आपका ऑर्डर {{time, timeFromTimestamp}} से पहले देना होगा, अन्यथा यह अमान्य हो जाएगा',
                    button: 'ठीक है',
                },
                location_permission: {
                    cancel: 'रद्द करें',
                    proceed: 'आगे बढ़ें',
                },
            },
            card_payment_authentication: {
                title: 'भुगतान प्रमाणीकरण',
                note: 'कृपया इस विंडो को तब तक खुला रखें जब तक आप अपने बैंक से प्रमाणीकरण प्रक्रिया पूरी नहीं कर लेते।',
            },
            maps: {
                cancel: 'रद्द करें',
                use_location: 'स्थान का प्रयोग करें',
            },
            app_refresh: {
                refresh: 'रीफ्रेश करें',
                title: 'रिफ्रेश स्टोर',
                description: 'हमारे स्टोर को अपडेट किया गया है. नवीनतम संस्करण तक पहुँचने के लिए कृपया अपने ब्राउज़र को ताज़ा करें। ताज़ा करने के बाद, आपको चेकआउट प्रक्रिया को आगे बढ़ाने के लिए अपने कार्ट को फिर से खोलने की आवश्यकता हो सकती है।',
            },
        },
        sections: {
            nav_top: {
                guest: 'अतिथि',
                login: 'लॉग इन',
                login_signup: 'लॉग इन / साइन अप',
                logout: 'लॉग आउट',
            },
            menus: {
                info: {
                    no_menus: 'फिलहाल कोई मेनू उपलब्ध नहीं है',
                    restrictions: 'मेनू प्रतिबंध',
                    not_available: 'मेनू अनुपलब्ध',
                    unavailable: {
                        times: 'मेनू उपलब्ध नहीं है, आपका ऑर्डर नीचे दिए गए समय से मेल नहीं खाता',
                        services: 'मेनू उपलब्ध नहीं है, आपका ऑर्डर नीचे दी गई सेवाओं से मेल नहीं खाता',
                        hours: 'मेनू उपलब्ध नहीं है, आपके ऑर्डर के समय इस मेनू के उपलब्ध घंटों के भीतर नहीं आते',
                        pre_order: 'मेनू उपलब्ध नहीं है, आपका ऑर्डर प्री-ऑर्डर आवश्यकताओं से मेल नहीं खाता',
                        age: 'मेनू उपलब्ध नहीं है, इस मेनू से ऑर्डर करने के लिए आपको आयु सत्यापित खाते से लॉग इन होना होगा',
                    },
                    services: {
                        title: 'ऑर्डर आवश्यकताएँ',
                        pickup: 'पिकअप',
                        delivery: 'डिलीवरी',
                        dine_in: 'डाइन-इन',
                    },
                    times: {
                        now: 'कोई पूर्व-आदेश नहीं',
                        later: 'केवल प्री-ऑर्डर',
                    },
                    hours: {
                        title: 'उपलब्ध घंटे',
                    },
                    preorder: {
                        title: 'प्री-ऑर्डर आवश्यकताएँ',
                        days_in_advance: '{{days}} दिन पहले ऑर्डर करना होगा',
                        cutoff_time: 'अंतिम दिन का कट-ऑफ समय {{time, timeFromTime}} पर',
                    },
                    age_restricted: {
                        title: 'आयु प्रतिबंधित',
                        approved: 'आपका खाता सत्यापित है और आप इस मेनू से ऑर्डर कर सकते हैं',
                        rejected: 'ऑर्डर करने के लिए आयु सत्यापन की आवश्यकता है। एक खाता बनाएं और अपनी आईडी अपलोड करें',
                    },
                },
                search: {
                    title: 'मेनू आइटम खोजें',
                    no_result: 'कुछ भी वापस नहीं आया. कोई अन्य खोज शब्द आज़माएँ?',
                    placeholder: 'तुम क्या ढूंढ रहे हो?',
                },
            },
            category: {
                restrictions: 'श्रेणी प्रतिबंध',
                not_available: 'श्रेणी अनुपलब्ध',
                unavailable: {
                    services: 'श्रेणी उपलब्ध नहीं है, आपका ऑर्डर नीचे दी गई आवश्यकताओं से मेल नहीं खाता',
                    hours: 'श्रेणी उपलब्ध नहीं है, आपके ऑर्डर का समय इस श्रेणी के उपलब्ध समय के भीतर नहीं है',
                },
            },
            info: {
                location: {
                    title: 'स्थान',
                    view_map: 'मानचित्र देखें',
                    phone: 'फ़ोन',
                },
                hours: {
                    title: 'खुलने का समय',
                    title_special: 'विशेष खुलने का समय',
                },
                services: {
                    title: 'सेवाएं',
                    notes: 'नोट्स',
                    delivery: {
                        ranges: 'डिलिवरी रेंज',
                        zones: 'वितरण क्षेत्र',
                        view_zones: 'मानचित्र पर क्षेत्र देखें',
                        fee: 'वितरण शुल्क',
                        fee_short: 'शुल्क',
                        fee_varies: 'भिन्न, कार्ट में दिखाया गया है',
                        min_order: 'न्यूनतम ऑर्डर',
                        min_order_short: 'न्यून. ऑर्ड.',
                        no_min_order: 'कोई न्यूनतम आदेश नहीं',
                        free_amount: 'मुफ़्त डिलिवरी राशि',
                    },
                },
            },
            contact: {
                title: 'हमसे संपर्क करें',
                name: 'नाम',
                email: 'ईमेल',
                phone: 'फ़ोन नंबर',
                message: 'अपना संदेश दर्ज करें...',
                send: 'मेसेज भेजें',
                success: 'आपका संदेश सफलतापूर्वक चला गया है',
                error: 'कुछ गलत हो गया, पुनः या बाद में प्रयास करें',
            },
            footer: {
                powered_by: 'द्वारा संचालित',
                terms_and_conditions: 'नियम एवं शर्तें',
                privacy: 'गोपनीयता नीति',
                cookie: 'कूकी नीति',
            },
        },
        pages: {
            payment_completed: {
                title: 'आपका भुगतान संसाधित हो गया था. आपके ऑर्डर के लिए धन्यवाद!',
                subtitle: 'ऑर्डर की जानकारी आपके ईमेल पते पर भेज दी गई है।',
                back_to_menu: 'मैन्यू में वापस',
                close_tab: 'इस टैब को बंद करें',
            },
            payment_failed: {
                title: 'दुर्भाग्य से आपका भुगतान संसाधित करते समय एक त्रुटि हुई।',
                subtitle: '',
                back_to_menu: 'मैन्यू में वापस',
                close_tab: 'इस टैब को बंद करें',
            },
        },
        // MODELS
        booking: {
            receipt: {
                title: 'बुकिंग रसीद',
                details: {
                    datetime: 'के लिए बुकिंग',
                    number_of_people: 'लोगों की संख्या',
                    placed: 'ऑर्डर किया गया',
                    updated: 'अंतिम अपडेट',
                    notes: 'नोट्स',
                    name: 'नाम',
                    email: 'ईमेल',
                    phone: 'फ़ोन',
                    store_address: 'स्टोर का पता',
                },
                status_update: {
                    title: 'बुकिंग {{number}} अपडेट की गई',
                    body: 'आपकी बुकिंग स्थिति {{status}} पर अपडेट कर दी गई है',
                },
                email_common: {
                    name: 'नाम: {{name}}',
                    phone: 'फ़ोन: {{number}}',
                    number_of_people: 'व्यक्तियों की संख्या: {{number}}',
                    date: 'दिनांक: {{date}}',
                    time: 'समय: {{time}}',
                    location: 'स्टोर स्थान: {{name}}',
                    notes: 'टिप्पणियाँ: {{name}}',
                },
                email_new_booking_restaurant: {
                    subject: 'नई टेबल बुकिंग {{number}} द्वारा {{name}}',
                    powered_by: '{{name}} द्वारा संचालित',
                    overview: 'नई टेबल बुकिंग अनुरोध',
                    title: '{{name}} के लिए नई बुकिंग',
                    subtitle: 'बुकिंग नंबर {{number}}',
                    description_confirmed: 'बुकिंग स्वचालित रूप से पुष्टि की गई है. आप इसे व्यवस्थापक डैशबोर्ड के माध्यम से रद्द कर सकते हैं और आपके ग्राहक को ईमेल द्वारा सूचित किया जाएगा',
                    description_unconfirmed: 'कृपया व्यवस्थापक डैशबोर्ड के माध्यम से बुकिंग की पुष्टि करें या रद्द करें',
                    url_pre_text: 'यहां देखें और अपडेट करें',
                },
                email_new_booking_customer: {
                    subject: 'टेबल बुकिंग अनुरोध',
                    powered_by: '{{name}} द्वारा संचालित',
                    overview: 'नई टेबल बुकिंग अनुरोध',
                    title: 'आपकी बुकिंग के लिए धन्यवाद',
                    subtitle: 'बुकिंग नंबर {{number}}',
                    description: '<b>जब आपकी बुकिंग की पुष्टि या अस्वीकृत हो जाएगी तो आपको एक और ईमेल प्राप्त होगी।</b><br>अपनी बुकिंग में कोई भी बदलाव करने के लिए कृपया हमसे संपर्क करें। आपकी बुकिंग का विवरण इस प्रकार है:',
                    url_pre_text: 'आप अपनी वास्तविक समय की बुकिंग रसीद यहां देख सकते हैं',
                },
                email_update_booking_customer: {
                    subject_confirmed: 'टेबल बुकिंग की पुष्टि',
                    subject_unconfirmed: 'टेबल बुकिंग रद्द',
                    powered_by: '{{name}} द्वारा संचालित',
                    overview: 'टेबल बुकिंग अनुरोध',
                    title_confirmed: 'बुकिंग संपुष्ट',
                    title_unconfirmed: 'बुकिंग रद्द',
                    subtitle: 'बुकिंग नंबर {{number}}',
                    description_confirmed: 'हम आगे आपसे मिलंगे। अपनी बुकिंग में किसी भी बदलाव के अनुरोध के लिए कृपया हमसे संपर्क करें',
                    description_unconfirmed: 'हमें आपको यह बताते हुए खेद है कि आपका बुकिंग अनुरोध स्वीकार नहीं किया जा सका। होने वाली किसी भी असुविधा के लिए हमें खेद है। यदि आपके कोई प्रश्न हैं तो कृपया हमसे से संपर्क करें',
                    url_pre_text: 'आप अपनी वास्तविक समय की बुकिंग रसीद यहां देख सकते हैं',
                },
                email_status_update_customer: {
                    subject: 'बुकिंग #{{number}} – {{subjectLabel}}',
                    body: '{{store}} में आपकी बुकिंग #{{number}} अब {{status}} है।',
                },
                errors: {},
                status_warning: 'बुकिंग पृष्ठ में अपने व्यवस्थापक डैशबोर्ड में इस बुकिंग की स्थिति अपडेट करें',
            },
        },
        email_delayed_order: {
            subject: 'ऑर्डर #{{number}} – {{subjectLabel}}',
            header: 'अपडेट किया गया तैयार समय',
            title: 'अपडेट किया गया तैयार समय',
            order_number: 'ऑर्डर संख्या: {{number}}',
            description: 'आपका ऑर्डर अब {{time}} पर तैयार होगा।',
            order_time_updated_to: 'आपके ऑर्डर का समय अपडेट हो गया है।',
            powered_by: '{{name}} द्वारा संचालित',
            button_text: 'ऑर्डर पर नज़र रखना',
            subject_label: 'अपडेट किया गया तैयार समय',
            subject_label_delivery: 'अपडेट किया गया डिलीवरी समय',
            body_ready: 'आपका ऑर्डर अब {{time}} पर तैयार होगा।',
            body_delivery: 'आपका ऑर्डर अब {{time}} पर डिलीवर होगा।',
        },
        order: {
            receipt: {
                est_ready_time: 'ईएसटी। तैयार समय',
                est_driver_pickup_time: 'ईएसटी। ड्राइवर पिकअप का समय',
                est_delivery_time: 'ईएसटी। डिलीवरी का समय',
                tab_details: 'विवरण',
                tab_dishes: 'आइटम',
                future_order: 'भविष्य का ऑर्डर',
                reprint: 'पुनः प्रिंट',
                details: {
                    order_no: 'ऑर्डर संख्या',
                    status: 'स्थिति',
                    placed: 'ऑर्डर किया गया',
                    due: 'समय',
                    due_asap: 'अभी / यथाशीघ्र',
                    last_updated: 'अंतिम अपडेट',
                    total: 'कुल',
                    type: 'प्रकार',
                    origin: 'स्रोत',
                    table: 'टेबल',
                    number_of_people: 'लोगों की संख्या',
                    payment_method: 'भुगतान विधि',
                    payment_status: 'भुगतान की स्थिति',
                    payment_currency: 'भुगतान मुद्रा',
                    notes: 'नोट्स',
                    name: 'नाम',
                    email: 'ईमेल',
                    phone: 'फ़ोन',
                    distance: 'दूरी',
                    driving_time: 'ड्राइविंग समय',
                    delivery_zone: 'क्षेत्र',
                    delivery_address: 'डिलीवरी का पता',
                    delivery_provider: 'डिलीवरी प्रदाता',
                    delivery_tracking: 'डिलीवरी ट्रैकिंग',
                    delivery_return_tracking: 'रिटर्न ट्रैकिंग',
                    delivery_tracking_link: 'ऑर्डर ट्रैक करें',
                    tookan_status: 'टूकन स्थिति',
                    tookan_status_failed_book: 'डिलीवरी बुक करने में विफल',
                    tookan_status_failed_update: 'बुकिंग अपडेट करने में विफल',
                    tookan_status_success: 'डिलीवरी के लिए बुक किया गया',
                    store_address: 'स्टोर का पता',
                    destination: 'गंतव्य',
                    estimated_arrival_time: 'अनुमानित आगमन समय',
                    delivery_status: 'स्थिति',
                    delivery_track_your_order: 'अपने ऑर्डर को ट्रैक करें',
                    delivery_text: 'डिलीवरी',
                    arrival_date: 'आगमन तिथि',
                },
                dishes: {
                    headings: {
                        quantity: 'मात्रा',
                        item: 'आइटम',
                        price: 'कीमत',
                    },
                    notes: 'नोट्स',
                    remove_ingredients: 'सामग्री हटाएं',
                },
                status_update: {
                    title: 'आदेश {{number}} अद्यतन किया गया',
                    body: 'आपके ऑर्डर की स्थिति {{status}} पर अपडेट कर दी गई है',
                },
                wait_time_update: {
                    title: 'आदेश {{number}} अद्यतन किया गया',
                    body: 'आपके ऑर्डर का नियत समय अपडेट कर दिया गया है',
                },
                delivery_update: {
                    title: 'आदेश {{number}} अद्यतन किया गया',
                    body: 'आपका ऑर्डर डिलीवरी के लिए बुक कर लिया गया है। वास्तविक समय ट्रैकिंग लिंक देखें',
                },
                payment_status_update: {
                    title: 'आदेश {{number}} अद्यतन किया गया',
                    body: 'आपके ऑर्डर भुगतान की स्थिति अपडेट कर दी गई है.',
                },
                email_new_order_restaurant: {
                    subject: 'नया आदेश ({{number}}) - {{name}}',
                    powered_by: '{{name}} द्वारा संचालित',
                    overview: 'नये आदेश की अधिसूचना',
                    title: 'नया ऑर्डर {{name}} पर दिया गया',
                    subtitle: 'ऑर्डर संख्या {{number}}',
                    description: 'अपने व्यवस्थापक डैशबोर्ड के माध्यम से विवरण और अपडेट देखें',
                    button_text: 'ऑर्डर पर नज़र रखना',
                    track_delivery_button_text: 'ट्रैक डिलिवरी',
                },
                email_new_order_customer: {
                    subject: 'ऑर्डर रसीद ({{number}})',
                    powered_by: '{{name}} द्वारा संचालित',
                    overview: 'नये आदेश की अधिसूचना',
                    title: 'नया ऑर्डर {{name}} पर दिया गया',
                    subtitle: 'ऑर्डर संख्या {{number}}',
                    description: 'अपनी वास्तविक समय की ऑनलाइन रसीद के माध्यम से विवरण और अपडेट देखें',
                    button_text: 'ऑर्डर पर नज़र रखना',
                    track_delivery_button_text: 'ट्रैक डिलिवरी',
                },
                email_order_completed_by_customer: {
                    subject: 'ऑर्डर ({{number}}) ग्राहक द्वारा पूरा किया गया',
                    powered_by: '{{name}} द्वारा संचालित',
                    overview: 'आदेश पूर्ण अधिसूचना',
                    title: 'ऑर्डर {{name}} पर पूरा हुआ',
                    subtitle: 'ऑर्डर संख्या {{number}}',
                    description: 'अपने डैशबोर्ड के माध्यम से या रसीद का उपयोग करके अपने ऑर्डर का विवरण देखें और अपडेट करें',
                },
            },
            totals: {
                tax: '{{name}} ({{percent}}%)',
                tax_in_prices: '{{name}} ({{percent}}%) इंक. कीमत में',
                fee: '{{name}} ({{value, currency}} + {{percent}}%)',
                fee_percent: '{{name}} ({{percent}}%)',
                fee_fixed: '{{name}}',
                delivery_fee: 'वितरण शुल्क',
                delivery_fee_offset: 'डिलिवरी शुल्क में छूट',
                delivery_fee_total: 'डिलिवरी शुल्क कुल',
                promo: 'छूट: {{name}} ({{value, currency}} + {{percent}}% छूट)',
                promo_percent: 'छूट: {{name}} ({{percent}}%)',
                promo_fixed: 'छूट: {{name}}',
                promo_none: 'छूट: {{name}}',
                cart: 'कार्ट',
                tip: 'टिप',
                total: 'कुल',
            },
            status: {
                unconfirmed: 'अप्रमाणित',
                awaiting_payment: 'भुगतान की प्रतीक्षा',
                confirmed: 'पुष्टि की गई',
                ready: 'तैयार',
                on_route: 'रास्ते में',
                complete: 'पूर्ण',
                cancelled: 'रद्द किया गया',
                seated: 'बैठाया गया',
            },
            searching: {
                lalamove_search_placeholder: 'लालामूव डिलीवरी आईडी द्वारा ऑर्डर खोजें',
            },
        },
        restaurant: {
            menus: {
                option_set: {
                    option: {
                        unavailable: 'उपलब्ध नहीं',
                    },
                },
                dish: {
                    no_stock: 'स्टॉक ख़त्म',
                    not_available: 'उपलब्ध नहीं है',
                },
            },
        },
        admin: {
            registration: {
                register_confirmation_code_subject: 'ई-मेल पुष्टिकरण कोड',
                register_confirmation_code_email: 'आपका ईमेल पुष्टिकरण कोड {{confirmation_code}} है (24 घंटे में समाप्त हो जाएगा)',
                register_confirmation_code_email_onbehalf: 'आपका ईमेल पुष्टिकरण कोड {{confirmation_code}} है (24 घंटे में समाप्त हो जाएगा)। यह ईमेल पते, {{email}} के लिए है।',
            },
        },
    },
};
//# sourceMappingURL=hi.js.map